import { useIntl } from 'react-intl';

import { DatasetDialogType, useDatasetModalContext } from '../context/DatasetManifestDialogContext';

export const useDatasetDeliveryTableHeader = () => {
  const intl = useIntl();
  const { activeDialog } = useDatasetModalContext();
  return {
    pageTitle: intl.formatMessage({
      id: 'dataset-delivery.title',
      defaultMessage: 'Dataset detail',
    }),
    isViewDatasetDetailModalOpen: activeDialog === DatasetDialogType.VIEW_DATASET_DETAIL,
  };
};
